import { IScope } from "angular";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../shared/components/views/machines/detail/tabs";
import { MachineThreeRivers } from "../models/machine";
import { MachineConfigurationThreeRivers } from "../models/machineConfiguration";
import { IReportGroup } from "../../../reporting/interfaces/IReportGroup";
import { vsComponentName as machinePartsComponentName } from "../../../parts.machines/components/machineParts";
import {
  ServerUtility,
  vsName as serverUtilityName,
} from "../../../records/server/serverUtility";
import { MachineDetailConfigurationViewArgs } from "../../shared/components/views/machines/detail/views/configurations/controller";
import { Machine } from "../../shared/models/machine";
import { vsName as partTransactionComponentName } from "../../../parts/Pages/detail/partTransaction";
// import { vsName as processDetailComponentName } from "./../../../Process/views/ProcessDetail/component";
// import { StateParams } from "@uirouter/angularjs";
// import { ServiceResponse } from "../../../records/server/query";
// import { vsComponentName as processViewComponentName } from "../../../Process/views/Process/component";
// import {
//   GridSettingsService,
//   vsName as GridSettingsServiceName,
// } from "../../../records/grids/settings/gridSettingsService";
// import {
//   ProcessInformationService,
//   vsServiceName as ProcessInformationServiceName,
// } from "../../../Process/services/processInformationService";

export function machineDetailTabComponentConfigure(
  machineDetailTabsProvider: MachineDetailTabsProvider,
) {
  machineDetailTabsProvider
    .addElement({
      displayName: "Configurations",
      id: "configurations",
      uiSrefFragment: "configurations",
      requiredPermission: "machineView",
      children: [],
      stateDefinition: {
        url: "/configurations",
        template: require("!html-loader!./configurations.html").default,
        controller: [
          "$scope",
          "machine",
          "allProgressiveCalculatedFields",
          "reportGroup",
          (
            $scope: IScope,
            machine: MachineThreeRivers,
            allProgressiveCalculatedFields: any[],
            reportGroup: IReportGroup
          ) => {
            const s = <any>$scope;
            s.machine = machine;
            s.reportGroup = reportGroup;
            s.editSref = "^.edit";
            s.accordionHeading = (args: MachineDetailConfigurationViewArgs) => {
              const machineConfiguration = <MachineConfigurationThreeRivers>(
                args.machineConfiguration
              );
              const { changeIsPending, dateString, currentConfiguration } =
                args;

              const conversionTypeName =
                machineConfiguration.MachineConversionType?.Name ?? "";
              const changeTypeSuffix = conversionTypeName
                ? ` (${conversionTypeName})`
                : "";
              machineConfiguration.MachineConversionType?.Name;

              return `${
                machineConfiguration.ChangeType
              }${changeTypeSuffix} - ${dateString}${
                currentConfiguration && !changeIsPending ? " - Current" : ""
              }${changeIsPending ? " - Pending" : ""}`;
            };

            s.getProgressiveCalculatedFields = (machineTypeId: number) =>
              allProgressiveCalculatedFields.find(
                (cf: any) => cf.MachineTypeIdId == machineTypeId
              );
          },
        ],
      },
    })
    .addElement({
      displayName: "Parts",
      id: "parts",
      uiSrefFragment: "parts",
      requiredPermission: "machineView",
      stateDefinition: {
        url: "/parts",
        component: partTransactionComponentName,
        resolve: {
          partTransaction: [
            serverUtilityName,
            "machine",
            (
              serverUtility: ServerUtility,
              machine: Machine<MachineConfigurationThreeRivers>,
            ) =>
              serverUtility.query({
                url: "/api/parts/partTransaction",
                query: {
                  ContextPath: "MachineId",
                  ContextValue: machine.Id,
                },
              }),
          ],
        },
      },
    });
  /*.addElement({
      id: "Process",
      displayName: "Process",
      uiSrefFragment: "Process",
      stateDefinition: {
        component: processViewComponentName,
        url: "/Process",
        resolve: {
          gridSettings: [
            GridSettingsServiceName,
            (gridSettingsService: GridSettingsService) =>
              gridSettingsService.getGridSettings(
                Symbol("machine.processView")
              ),
          ],
          processDetails: [
            ProcessInformationServiceName,
            (processInformationService: ProcessInformationService) =>
              processInformationService.getProcessInformation(),
          ],
        },
      },
      children: [
        {
          id: "detail",
          displayName: "Detail",
          uiSrefFragment: "detail",
          stateDefinition: {
            url: "/detail/{processInstancesId:int}",
            component: processDetailComponentName,
            resolve: {
              model: [
                serverUtilityName,
                "$stateParams",
                function (
                  serverUtility: ServerUtility,
                  $stateParams: StateParams
                ) {
                  const processInstancesId = $stateParams["processInstancesId"];
                  return serverUtility
                    .sendApiRequest({
                      method: "get",
                      url: `/api/processes/machines/information?processInstancesId=${processInstancesId}`,
                    })
                    .then((r) => (<ServiceResponse<unknown[]>>r).Results.at(0));
                },
              ],
              tree: [
                serverUtilityName,
                "$stateParams",
                "model",
                function (
                  serverUtility: ServerUtility,
                  $stateParams: StateParams,
                  model: any
                ) {
                  const processInstancesId = $stateParams["processInstancesId"];
                  return serverUtility
                    .sendApiRequest({
                      method: "get",
                      url: `/api/processes/${model.Type}/${processInstancesId}`,
                    })
                    .then((r) => (<ServiceResponse<unknown>>r).Result);
                },
              ],
              processInformation: [
                ProcessInformationServiceName,
                "model",
                (
                  processInformationService: ProcessInformationService,
                  model: { Type: string }
                ) =>
                  processInformationService.getProcessInformationByType(
                    model.Type
                  ),
              ],
            },
            bindings: {
              machine: "model",
            },
          },
        },
      ],
    })*/
}
machineDetailTabComponentConfigure.$inject = [MachineDetailTabsProviderName];
